module.exports = __webpack_public_path__ + "media/images/ask-question-banner-4160493fe33ffc8aa0d14b4896a5ff76.jpg";